
/*
* action types
*/

export const SET_SELL_TYPE = 'SET_SELL_TYPE'
export const SET_BIEN_TYPE = 'SET_BIEN_TYPE'
export const SET_REFERENCE = 'SET_REFERENCE'
export const SET_CITY = 'SET_CITY'
export const SET_CHAMBRES_RANGE = 'SET_CHAMBRES_RANGE'
export const SET_CHAMBRES_VALUES = 'SET_CHAMBRES_VALUES'
export const SET_SURFACE_RANGE = 'SET_SURFACE_RANGE'
export const SET_SURFACE_VALUES = 'SET_SURFACE_VALUES'
export const SET_PRIX_RANGE = 'SET_PRIX_RANGE'
export const SET_PRIX_VALUES = 'SET_PRIX_VALUES'

/*
* action creators
*/

export function setSellType(data) {
    return { type: SET_SELL_TYPE, payload: data };
}

export function setBienType(data) {
    return { type: SET_BIEN_TYPE, payload: data };
}

export function setReference(data) {
    return { type: SET_REFERENCE, payload: data };
}

export function setCity(data) {
    return { type: SET_CITY, payload: data };
}

export function setChambresRange(data) {
    return { type: SET_CHAMBRES_RANGE, payload: data };
}

export function setChambresValues(data) {
    return { type: SET_CHAMBRES_VALUES, payload: data };
}

export function setSurfaceRange(data) {
    return { type: SET_SURFACE_RANGE, payload: data };
}

export function setSurfaceValues(data) {
    return { type: SET_SURFACE_VALUES, payload: data };
}

export function setPrixRange(data) {
    return { type: SET_PRIX_RANGE, payload: data };
}

export function setPrixValues(data) {
    return { type: SET_PRIX_VALUES, payload: data };
}
